/* @flow */

import {
  sideBarLapWidth,
  sideBarTabletWidth,
  mainTabletWidth,
  mainLapWidth,
} from 'src/shared/app/base/component/template/style/template.style';
import { notificationElevation } from 'src/shared/app/base/style/token/elevation';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';
import { topBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  root: {
    position: 'fixed',
    top: topBarHeight,
    left: 0,
    zIndex: ({ elevation }: Object) => elevation || notificationElevation,

    width: '100%',

    [tablet]: {
      left: sideBarTabletWidth,

      maxWidth: mainTabletWidth,
    },

    [lap]: {
      left: sideBarLapWidth,

      maxWidth: mainLapWidth,
    },
  },
};
